var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal__mask",on:{"click":_vm.clickMaskClose}},[_c('div',{staticClass:"modal__wrapper"},[_c('div',{class:[
          'modal__container',
          _vm.noScroll ? 'modal__container_no-scroll' : ''
        ],style:(_vm.slotStyle),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }